import React from "react";
import { Alert, Badge, Card, Col, Container, Row } from "react-bootstrap";
import { PiEmptyBold } from "react-icons/pi";
import { useSearchParams } from "react-router-dom";
import Loader from "../../../components/custom/Loader";
import { useVerifyCertificateQuery } from "../../../redux/api/dashboardApiSlice";
export default function CertificateVerify() {
  const [searchParams] = useSearchParams();

  const issued = searchParams.get("issued");
  const regNo = searchParams.get("regNo");

  const { data, isLoading } = useVerifyCertificateQuery(
    {
      issued,
      regNo,
    },
    {
      skip: !issued || !regNo,
    }
  );

  // If loading, show the Loader component
  if (isLoading) {
    return <Loader />;
  }

  // If no data, show an alert
  if (!data?.data) {
    return (
      <div>
        <section className="section py-5 service-single">
          <Container>
            <Row className="justify-content-center">
              <Col md={8} lg={6}>
                <div className="d-flex justify-content-center align-items-center">
                  <div className="text-center card p-4">
                    <div>
                      <PiEmptyBold size={90} className="text-danger m-3" />
                    </div>
                    <Alert variant="warning">
                      {data?.data.lang === 1
                        ? "কোনো রেকর্ড পাওয়া যায়নি।"
                        : "No Record Found."}
                    </Alert>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section> 
      </div>
    );
  }

  return (
    <div>
      <section className="section py-5 service-single">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6}>
              <div className="card shadow-sm p-4">
                <h3 className="text-center mb-4 fw-semibold">
                  {data?.data.lang === 1
                    ? "সার্টিফিকেট যাচাই করুন"
                    : "Certificate Verification"}
                </h3>
                <Card>
                  <Card.Body>
                    <h5 className="card-title">
                      {data?.data.lang === 1
                        ? data?.data.certificateType === 1
                          ? "কপিরাইট সার্টিফিকেট"
                          : "রিলেটেড রাইট সার্টিফিকেট"
                        : data?.data.certificateType === 1
                        ? "Copyright"
                        : "Related Right"}
                    </h5>

                    <ul className="list-unstyled">
                      <li>
                        <strong>
                          {data?.data.lang === 1
                            ? "রেজিস্ট্রেশন নং:"
                            : "Registration No:"}
                        </strong>{" "}
                        {data?.data.registrationNo}
                      </li>
                      <li></li>
                      <li className="d-flex gap-3">
                        <div>
                          <strong>
                            {data?.data.lang === 1
                              ? "রেজিস্ট্রেশন তারিখ:"
                              : "Registration Date:"}
                          </strong>{" "}
                          {data?.data.registrationDate}
                        </div>
                        <div>
                          <strong>
                            {data?.data.lang === 1 ? "বৈধতার মেয়াদ:" : "Validity:"}
                          </strong>{" "}
                          {data?.data.validity}
                        </div>
                      </li>
                    </ul>

                    <ul className="list-unstyled">
                      <li>
                        <strong>
                          {data?.data.lang === 1
                            ? "মেধা কর্মের শিরোনাম:"
                            : "Title of the Intellectual Work:"}
                        </strong>{" "}
                        {data?.data.workTitle}
                      </li>
                      <li>
                        <strong>
                          {data?.data.lang === 1
                            ? "কর্মের স্বত্বাধিকারী:"
                            : "Owner of the Intellectual Work:"}
                        </strong>{" "}
                        {data?.data.owners}
                      </li>
                      <li>
                        <strong>
                          {data?.data.lang === 1
                            ? "মেধা কর্মের প্রণেতা:"
                            : " Author of The Intellectual Work:"}
                        </strong>{" "}
                        {data?.data.authors}
                      </li>
                      <li>
                        <strong>
                          {data?.data.lang === 1
                            ? "স্বত্ব প্রাপ্তির মাধ্যম:"
                            : "Mode of Ownership Gain:"}
                        </strong>{" "}
                        {data?.data.ownergain}
                      </li>
                      <li>
                        <strong>
                          {data?.data.lang === 1
                            ? "মেধা কর্মের ক্ষেত্র:"
                            : "Field of the Work:"}
                        </strong>{" "}
                        {data?.data.fieldWork}
                      </li>
                    </ul>

                    <ul className="list-unstyled">
                      <li>
                        <strong>
                          {data?.data.lang === 1
                            ? data?.data.certificateCanceled
                              ? "সার্টিফিকেট বাতিলের তারিখ:"
                              : "সার্টিফিকেট প্রদানের তারিখ:"
                            : data?.data.certificateCanceled
                            ? "Certificate Cancel Date:"
                            : "Certificate Issue Date:"}
                        </strong>{" "}
                        {data?.data.cerIssueDate}
                      </li>
                    </ul>

                    <div className="mt-4">
                     <strong>Status: </strong> {data?.data.certificateCanceled ? (
                        <Badge bg="danger">
                          {data?.data.lang === 1
                            ? "সার্টিফিকেট বাতিল করা হয়েছে"
                            : "Certificate Canceled"}
                        </Badge>
                      ) : (
                        <Badge bg="success" className="p-2" style={{
                          fontSize:"14px"
                        }}>
                          {data?.data.lang === 1
                            ? "সার্টিফিকেট বৈধ"
                            : "Certificate Valid"}
                        </Badge>
                      )}
                    </div>
                  </Card.Body>
                </Card>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
}
